export function getPinnedSearchFilterIds(availableSearchFilters = {}) {
  return Object.entries(availableSearchFilters)
    .filter(([, field]) => field.pinned)
    .map(([id]) => id);
}

export function isPinnedSearchFilter(id, pinnedIds = []) {
  return pinnedIds.includes(id);
}

/**
 * Ensures pinned filter ids are present in order.
 * When pinAtStart is true, pinned ids are moved to the front (Products tab).
 */
export function ensurePinnedSearchFiltersOrder(order = [], pinnedIds = [], { pinAtStart = false } = {}) {
  if (!pinnedIds.length) return [...order];

  const rest = order.filter((id) => !pinnedIds.includes(id));

  if (pinAtStart) {
    return [...pinnedIds, ...rest];
  }

  const missingPinned = pinnedIds.filter((id) => !order.includes(id));
  return [...order, ...missingPinned];
}

/** Puts pinned filters first while preserving relative order of the rest. */
export function sortPinnedFiltersFirst(items = [], pinnedIds = []) {
  if (!pinnedIds.length || !items.length) return items;

  const pinnedItems = pinnedIds
    .map((id) => items.find((item) => item.id === id))
    .filter(Boolean);
  const rest = items.filter((item) => !pinnedIds.includes(item.id));

  return [...pinnedItems, ...rest];
}
